import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectSortDirection = (store: StoreSchema) =>
	store.licenseUpdates.sort.direction
